<template>
    <div class="alerts">
        <alert v-for="(alert, n) in alerts" :key="n" :obj="alert"></alert>
    </div>
</template>
<script>
import Alert from './Alert.vue'
export default {
    name: "Alerts",
    components: {
        Alert
    },
    data(){
        return{
            alerts: []
        }
    },
    watch: {
        '$root.alerts': {
            deep: true,
            handler(nV){
                this.alerts = nV
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .alerts{
        position: fixed;
        width: 100%;
        height: 0;
        text-align: right;
        right: 0;
        display: flex;
        max-width: 340px;
        justify-content: flex-end;
        flex-wrap: wrap;
        bottom: top;
        z-index: 100;
        
    }
</style>